import { useState } from 'react';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import CustomInput from '@/components/CustomInput/CustomInput';
import { useTranslation } from 'react-i18next';
import Button from '@/components/CustomButtons/Button';
import CountryDropdown from '@/components/CountryDropdown';

const NaupaContactForm = ({ id, naupaContact, setNaupaContact }) => {
  const { t } = useTranslation();
  const handleNaupaContactChange = (e) => {
    setNaupaContact({ ...naupaContact, [e.target.name]: e.target.value });
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactNameLabel', { id })}
          id={`naupaContact${id}Name`}
          name='name'
          onChange={handleNaupaContactChange}
          value={naupaContact.name}
          type='text'
          maxLength={40}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAddress1Label', {
            id,
          })}
          id={`naupaContact${id}Address1`}
          name='address1'
          onChange={handleNaupaContactChange}
          value={naupaContact.address1}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAddress2Label', {
            id,
          })}
          id={`naupaContact${id}Address2`}
          name='address2'
          onChange={handleNaupaContactChange}
          value={naupaContact.address2}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {'address3' in naupaContact && (
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.naupaContactAddress3Label', {
              id,
            })}
            id={`naupaContact${id}Address3`}
            name='address3'
            onChange={handleNaupaContactChange}
            value={naupaContact.address3}
            type='text'
            maxLength={30}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
      )}
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactCityLabel', { id })}
          id={`naupaContact${id}City`}
          name='city'
          onChange={handleNaupaContactChange}
          value={naupaContact.city}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactStateLabel', { id })}
          id={`naupaContact${id}State`}
          name='state'
          onChange={handleNaupaContactChange}
          value={naupaContact.state}
          type='text'
          maxLength={2}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactZipCodeLabel', { id })}
          id={`naupaContact${id}ZipCode`}
          name='zipCode'
          onChange={handleNaupaContactChange}
          value={naupaContact.zipCode}
          type='text'
          maxLength={9}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CountryDropdown
          id={`naupaContact${id}Country`}
          labelText={t('organizations.update.naupaContactCountryLabel', { id })}
          value={naupaContact.country}
          onChange={handleNaupaContactChange}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAreaCodeLabel', {
            id,
          })}
          id={`naupaContact${id}AreaCode`}
          name='areaCode'
          onChange={handleNaupaContactChange}
          value={naupaContact.areaCode}
          type='text'
          maxLength={3}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactTelNumberLabel', {
            id,
          })}
          id={`naupaContact${id}TelNumber`}
          name='telNumber'
          onChange={handleNaupaContactChange}
          value={naupaContact.telNumber}
          type='text'
          maxLength={7}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactTelExtensionLabel', {
            id,
          })}
          id={`naupaContact${id}TelExtension`}
          name='telExtension'
          onChange={handleNaupaContactChange}
          value={naupaContact.telExtension}
          type='text'
          maxLength={4}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactEmailLabel', { id })}
          id={`naupaContact${id}Email`}
          name='email'
          onChange={handleNaupaContactChange}
          value={naupaContact.email}
          type='text'
          maxLength={50}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
    </GridContainer>
  );
};

const NaupaInfoTab = ({ organization, updateOrganization }) => {
  const { t } = useTranslation();
  const [naupaContact1, setNaupaContact1] = useState({
    name: organization.naupaContact1Name || '',
    address1: organization.naupaContact1Address1 || '',
    address2: organization.naupaContact1Address2 || '',
    city: organization.naupaContact1City || '',
    state: organization.naupaContact1State || '',
    zipCode: organization.naupaContact1ZipCode || '',
    country: organization.naupaContact1Country || '',
    areaCode: organization.naupaContact1AreaCode || '',
    telNumber: organization.naupaContact1TelNumber || '',
    telExtension: organization.naupaContact1TelExtension || '',
    email: organization.naupaContact1Email || '',
  });
  const [naupaContact2, setNaupaContact2] = useState({
    name: organization.naupaContact2Name || '',
    address1: organization.naupaContact2Address1 || '',
    address2: organization.naupaContact2Address2 || '',
    address3: organization.naupaContact2Address3 || '',
    city: organization.naupaContact2City || '',
    state: organization.naupaContact2State || '',
    zipCode: organization.naupaContact2ZipCode || '',
    country: organization.naupaContact2Country || '',
    areaCode: organization.naupaContact2AreaCode || '',
    telNumber: organization.naupaContact2TelNumber || '',
    telExtension: organization.naupaContact2TelExtension || '',
    email: organization.naupaContact2Email || '',
  });
  const [faxAreaCode, setFaxAreaCode] = useState(
    organization.naupaFaxAreaCode || '',
  );
  const [faxNumber, setFaxNumber] = useState(organization.naupaFaxNumber || '');
  const handleFaxAreaCode = (e) => setFaxAreaCode(e.target.value);
  const handleFaxNumber = (e) => setFaxNumber(e.target.value);
  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append('naupaFaxAreaCode', faxAreaCode);
    formData.append('naupaFaxNumber', faxNumber);
    formData.append('naupaContact1Name', naupaContact1.name);
    formData.append('naupaContact1Address1', naupaContact1.address1);
    formData.append('naupaContact1Address2', naupaContact1.address2);
    formData.append('naupaContact1City', naupaContact1.city);
    formData.append('naupaContact1State', naupaContact1.state);
    formData.append('naupaContact1ZipCode', naupaContact1.zipCode);
    formData.append('naupaContact1Country', naupaContact1.country);
    formData.append('naupaContact1AreaCode', naupaContact1.areaCode);
    formData.append('naupaContact1TelNumber', naupaContact1.telNumber);
    formData.append('naupaContact1TelExtension', naupaContact1.telExtension);
    formData.append('naupaContact1Email', naupaContact1.email);
    formData.append('naupaContact2Name', naupaContact2.name);
    formData.append('naupaContact2Address1', naupaContact2.address1);
    formData.append('naupaContact2Address2', naupaContact2.address2);
    formData.append('naupaContact2Address3', naupaContact2.address3);
    formData.append('naupaContact2City', naupaContact2.city);
    formData.append('naupaContact2State', naupaContact2.state);
    formData.append('naupaContact2ZipCode', naupaContact2.zipCode);
    formData.append('naupaContact2Country', naupaContact2.country);
    formData.append('naupaContact2AreaCode', naupaContact2.areaCode);
    formData.append('naupaContact2TelNumber', naupaContact2.telNumber);
    formData.append('naupaContact2TelExtension', naupaContact2.telExtension);
    formData.append('naupaContact2Email', naupaContact2.email);

    await updateOrganization(formData);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            type='text'
            labelText={t('organizations.update.faxAreaCodeLabel')}
            onChange={handleFaxAreaCode}
            value={faxAreaCode}
            id='faxAreaCode'
            name='faxAreaCode'
            maxLength={3}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            type='text'
            labelText={t('organizations.update.faxNumberLabel')}
            onChange={handleFaxNumber}
            value={faxNumber}
            id='faxNumber'
            name='faxNumber'
            maxLength={7}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
      </GridContainer>

      <NaupaContactForm
        id={1}
        naupaContact={naupaContact1}
        setNaupaContact={setNaupaContact1}
      />
      <NaupaContactForm
        id={2}
        naupaContact={naupaContact2}
        setNaupaContact={setNaupaContact2}
      />
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Button color='primary' onClick={handleUpdate}>
            {t('common.buttons.update')}
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}></GridItem>
      </GridContainer>
    </>
  );
};

export default NaupaInfoTab;
